module.exports = __webpack_public_path__ + "media/images/v1/logo-72e3ce69f8930a67b4fa03d138fe9b3b.svg";